module.exports = __webpack_public_path__ + "img/logo-small.06552cf4.png";